import { Link } from "react-router-dom";
import { track, withAttribution } from "@/lib/analytics";
import { BENEFITS, SIGNUP_URL } from "../data";

export default function Benefits() {
  return (
    <section
      id="what-joble-does"
      className="relative bg-background-100 py-16 md:py-24 px-4 md:px-8 border-t border-background-300/20"
    >
      <div className="max-w-5xl mx-auto">
        <div className="reveal max-w-2xl mb-12">
          <div className="inline-flex items-center gap-2 rounded-full border border-background-300/40 px-4 py-1.5 mb-5">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="text-xs font-medium text-foreground-800 tracking-wide">
              What Joble does
            </span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-foreground-950 leading-tight tracking-tight">
            What Joble does, in one take
          </h2>
          <p className="mt-5 text-base text-foreground-700 leading-relaxed max-w-xl">
            Three things you feel the moment you switch it on. Explore the agent behind each one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {BENEFITS.map((benefit, index) => (
            <Link
              key={benefit.title}
              to={`/products#${benefit.productId}`}
              className="group reveal rounded-2xl border border-background-300/40 bg-background-50/60 p-6 md:p-7 flex flex-col gap-4 hover:border-primary-500/50 hover:bg-background-50/80 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center ${
                  index === 1
                    ? "bg-accent-500/12 border border-accent-500/25"
                    : "bg-primary-500/12 border border-primary-500/25"
                }`}
              >
                <i
                  className={`${benefit.icon} text-xl ${
                    index === 1 ? "text-accent-400" : "text-primary-400"
                  }`}
                  aria-hidden
                ></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950">{benefit.title}</h3>
              <p className="text-sm text-foreground-700 leading-relaxed">{benefit.description}</p>

              <span className="mt-auto inline-flex items-center gap-2 text-xs font-semibold text-primary-300 group-hover:text-primary-200 transition-colors">
                See {benefit.productName}
                <i
                  className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"
                  aria-hidden
                ></i>
              </span>
            </Link>
          ))}
        </div>

        <div className="reveal mt-12 text-center">
          <a
            href={withAttribution(SIGNUP_URL)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("try_joble_clicked", { location: "benefits_section" })}
            className="group inline-flex items-center justify-center gap-3 rounded-full bg-primary-500 text-foreground-950 font-semibold text-base px-8 py-4 hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Try Joble Now
            <span className="w-7 h-7 rounded-full bg-foreground-950/15 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <i className="ri-arrow-right-line text-foreground-950" aria-hidden></i>
            </span>
          </a>
          <p className="mt-3 text-xs text-foreground-600">
            Live in 5 minutes. No credit card, no developer.
          </p>
        </div>
      </div>
    </section>
  );
}